import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
    selector: '[appDisableControl]',
    standalone: false
})
export class DisableControlDirective {

  @Input() set disableControl(condition: boolean ) {
    if (!this.el) { return; }

    const action = condition ? 'disable' : 'enable';
    action === 'disable' ?
        this.el.nativeElement.setAttribute('disabled', `${action}`) :
        this.el.nativeElement.removeAttribute('disabled');
  }

  constructor(private el: ElementRef) {
  }
}
